import { getApiUrl, getEnvVar } from "@commons-monorepo/index";

export const getStoreInformationStats = (storeId: string) => {
  return fetch(`${getApiUrl()}/api/ms/order/store/${storeId}/statistic/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "api-key-sumer": getEnvVar("PUBLIC_API_KEY"),
    } as HeadersInit,
  });
};
